/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type SettingsResourcesSubNav_viewer = {
    readonly email: string | null;
    readonly " $refType": "SettingsResourcesSubNav_viewer";
};
export type SettingsResourcesSubNav_viewer$data = SettingsResourcesSubNav_viewer;
export type SettingsResourcesSubNav_viewer$key = {
    readonly " $data"?: SettingsResourcesSubNav_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SettingsResourcesSubNav_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SettingsResourcesSubNav_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
(node as any).hash = 'c8c3eef97856712fa711824bb3cbb742';
export default node;
